import { externalLink } from "@/routes/_constants/external-link";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useReservationDefaultIsShowPlanIncludedPrice } from "./hooks/use-is-show-plan-included-price";

/**
 * CHILLNN サポート「プラン料金を部屋料金と合算して表示したい」
 * https://support.chillnn.com/faq/host/reservation/3cafffe15c57816e8e69fcfebd0ea1eb
 *
 * ベースURLは externalLink.faqSite（dev/prd で自動切替）を使う。
 * パスは Notion ページ ID で構成されるため、日本語タイトルや旧スラッグは使わない。
 */
const PLAN_INCLUDED_PRICE_GUIDE_URL = `${externalLink.faqSite}/faq/host/reservation/3cafffe15c57816e8e69fcfebd0ea1eb`;

export const QuestionReservationDefaultIsShowPlanIncludedPrice = () => {
	const { isEdited, hasError, isShowPlanIncludedPrice, onSetIsShowPlanIncludedPrice } =
		useReservationDefaultIsShowPlanIncludedPrice();

	const title = "プラン料金と部屋料金を合算して表示する";
	const guide =
		`通常は、プラン料金はプラン選択画面に個別表示され、宿泊カレンダーには部屋料金のみが表示されます。<br />有効にすると、プラン料金は個別表示されず、宿泊カレンダーには部屋料金とプラン料金を合算した金額が表示されます。<br />詳しくは<a href="${PLAN_INCLUDED_PRICE_GUIDE_URL}" target="_blank" rel="noopener noreferrer" class="text-link-400 underline-offset-4 hover:underline">こちら</a>`;

	const label = "プラン料金と部屋料金を合算して表示する";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<CheckboxField
					value={isShowPlanIncludedPrice.value}
					label={label}
					handleChange={onSetIsShowPlanIncludedPrice}
				/>
			}
		/>
	);
};

QuestionReservationDefaultIsShowPlanIncludedPrice.displayName = "QuestionReservationDefaultIsShowPlanIncludedPrice";
